// Selected Pashu Haat (multi-haat, Enterprise). All API calls carry the
// selection via the X-Haat-Id header (see api.js) so every module loads
// the selected haat's data automatically.
const KEY = "am_haat_id";

export const getHaatId = () => localStorage.getItem(KEY) || "";

export const setHaatId = (id) => {
  if (id) localStorage.setItem(KEY, id);
  else localStorage.removeItem(KEY);
};
